export default __webpack_public_path__ + "static/media/computer.58beaf71.svg";